import React from 'react';
import { GoogleButton } from '../../../components/fields/buttons/socialButtons/GoogleButton';
import qs from 'qs';
import { APP_ROUTES } from '../../../routing/AppRoutes';

function handleGoogleBtnClick() {
  const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
  const urlQs = qs.stringify({
    client_id: clientId,
    redirect_uri: `${window.location.origin}${APP_ROUTES.GOOGLE_CALLBACK}`,
    response_type: 'token',
    scope: 'profile email',
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${urlQs}`;
}

export const GoogleButtonContainer: React.FC<any> = (props) => {
  return <GoogleButton onClick={handleGoogleBtnClick} {...props} />;
};
